import axios from 'axios'
import { Promotion } from '../../interfaces/promotion'

export const updatePromotion = (promotion: Promotion) => {
  return axios.put('/data/sadarbības_partnera_akcija/' + promotion.id, promotion)
}
